<h2 class="layout-sign-in-regular-title">{{ 'SIGN_IN.TITLE' | translate }}</h2>

<form [formGroup]="form" fxLayout="column">
  <mat-form-field fxFlex="100%">
    <mat-icon matPrefix>email</mat-icon>
    <input matInput formControlName="email" type="email" [placeholder]="'SIGN_IN.EMAIL' | translate"
           (input)="onChangeEmail($event)"/>
  </mat-form-field>

  <mat-form-field fxFlex="100%">
    <mat-icon matPrefix>lock</mat-icon>
    <input matInput formControlName="password" [type]="showPassword ? 'text' : 'password'"
           [placeholder]="'SIGN_IN.PASSWORD' | translate"/>
    <mat-icon class="layout-pointer-cursor" matSuffix (click)="showPassword = !showPassword">{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
  </mat-form-field>

  <div class="layout-sign-in-error" fxLayout="column" [class.error]="error">
    <em translate>SIGN_IN.FAILED_TITLE</em>
    <span [innerHTML]="error | translate"></span>
  </div>

  <div class="layout-sign-in-form-actions">
    <button class="progress-bar-button" mat-raised-button [disabled]="loading" (click)="signIn()">
      <mat-progress-bar
        class="progress-bar-button-gauge"
        [color]="'primary'"
        [mode]="'indeterminate'"
        *ngIf="loading"
      ></mat-progress-bar>
      <span translate>SIGN_IN.TITLE</span>
    </button>
  </div>
</form>
